import { Checkbox } from 'components/widgets';
import LabeledCheckboxList from 'components/widgets/LabeledCheckboxList';
import PropTypes from 'prop-types';
import React from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import { MetricFieldSchema, MetricValueSchema } from '../types';
import { translationPrefix } from '../utils';
import ExpandableGroup from './ExpandableGroup';
import css from './FieldGroups.css';
import SelectAll from './SelectAll';

const FieldGroups = ({ fields, allValues, onChange, enableAddFuture, translate }) => {
    const onGroupChange = (field, newState) =>
        onChange(
            field.values.map(item => item.name),
            Boolean(newState)
        );

    const onMetricSelected = (id, newState) => onChange([id], Boolean(newState));

    const selectAll = newState => {
        onChange(
            allValues.map(value => value.name),
            Boolean(newState)
        );
        if (newState) {
            enableAddFuture();
        }
    };

    return (
        <>
            <SelectAll allItems={allValues} onChange={selectAll} />
            {fields.map(field => {
                const selectedValues = field.values.filter(value => value.selected);
                const fieldChecked = selectedValues.length === field.values.length;
                const fieldIndeterminate = selectedValues.length > 0 && selectedValues.length < field.values.length;

                return (
                    <div className={css.expandableGroupHolder} key={field.label}>
                        <ExpandableGroup
                            title={<Translate id={field.label} />}
                            rightComponents={
                                <Checkbox
                                    label={translate(`${translationPrefix}.SELECTED_COUNT`, {
                                        selectedCount: selectedValues.length,
                                        totalCount: field.values.length,
                                    })}
                                    className={css.sectionCheckbox}
                                    labelPosition="left"
                                    checked={fieldChecked}
                                    threeStatesEnabled
                                    indeterminate={fieldIndeterminate}
                                    onChange={newState => onGroupChange(field, newState)}
                                />
                            }
                        >
                            <div>
                                <LabeledCheckboxList
                                    fields={field.values}
                                    columnsNumber={field.type === 'customEvents' ? 1 : 4}
                                    onChange={onMetricSelected}
                                />
                            </div>
                        </ExpandableGroup>
                    </div>
                );
            })}
        </>
    );
};

FieldGroups.propTypes = {
    fields: PropTypes.arrayOf(MetricFieldSchema.isRequired).isRequired,
    allValues: PropTypes.arrayOf(MetricValueSchema.isRequired).isRequired,
    onChange: PropTypes.func.isRequired,
    enableAddFuture: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(FieldGroups);
